export interface DiscoveryReport {
    id: string;
    nameEn: string;
    nameFr: string;
    descriptionEn: string;
    descriptionFr: string;
    approvers: string;
}

export interface DiscoveryCategory {
    categoryId: string;
    categoryName: string;
    reports: DiscoveryReport[];
}

export const discoveryReportsData: DiscoveryCategory[] = [
    {
        categoryId: "practice-management",
        categoryName: "Practice Management",
        reports: [
            {
                id: "pm-001",
                nameEn: "2023 Engagement Survey Results",
                nameFr: "Résultats de l'enquête d'engagement 2023",
                descriptionEn: "Comprehensive analysis of employee engagement metrics and satisfaction scores across all departments",
                descriptionFr: "Analyse complète des métriques d'engagement des employés et des scores de satisfaction dans tous les départements",
                approvers: "Andrew S."
            },
            {
                id: "pm-002",
                nameEn: "Employee Hiring and History Tracker",
                nameFr: "Suivi des embauches et de l'historique des employés",
                descriptionEn: "Track hiring patterns, employee retention rates, and historical employment data",
                descriptionFr: "Suivi des modèles d'embauche, des taux de rétention des employés et des données d'emploi historiques",
                approvers: "Sarah M."
            },
            {
                id: "pm-003",
                nameEn: "Partner WIP AR Report",
                nameFr: "Rapport WIP AR des partenaires",
                descriptionEn: "Work in progress and accounts receivable analysis for partner-level reporting",
                descriptionFr: "Analyse des travaux en cours et des comptes clients pour les rapports au niveau des partenaires",
                approvers: "Michael R."
            },
            {
                id: "pm-004",
                nameEn: "Performance Review Dashboard",
                nameFr: "Tableau de bord des évaluations de performance",
                descriptionEn: "Annual performance review metrics and employee development tracking",
                descriptionFr: "Métriques d'évaluation de performance annuelle et suivi du développement des employés",
                approvers: "Lisa K."
            },
            {
                id: "pm-005",
                nameEn: "Resource Allocation Report",
                nameFr: "Rapport d'allocation des ressources",
                descriptionEn: "Analysis of resource distribution across projects and departments",
                descriptionFr: "Analyse de la distribution des ressources entre les projets et départements",
                approvers: "David L."
            },
            {
                id: "pm-006",
                nameEn: "Training Completion Tracker",
                nameFr: "Suivi de completion de formation",
                descriptionEn: "Monitor training program completion rates and certification status",
                descriptionFr: "Surveiller les taux de completion des programmes de formation et le statut de certification",
                approvers: "Jennifer W."
            }
        ]
    },
    {
        categoryId: "market-analysis",
        categoryName: "Market and Analysis - long category with Characters 123@#$!*%^&()/+",
        reports: [
            {
                id: "ma-001",
                nameEn: "Market Trends Analysis Q4 2023",
                nameFr: "Analyse des tendances du marché T4 2023",
                descriptionEn: "Quarterly market analysis including competitor positioning and industry trends",
                descriptionFr: "Analyse trimestrielle du marché incluant le positionnement des concurrents et les tendances de l'industrie",
                approvers: "Robert T."
            },
            {
                id: "ma-002",
                nameEn: "Client Satisfaction Survey",
                nameFr: "Enquête de satisfaction client",
                descriptionEn: "Annual client satisfaction metrics and feedback analysis",
                descriptionFr: "Métriques annuelles de satisfaction client et analyse des commentaires",
                approvers: "Emma B."
            },
            {
                id: "ma-003",
                nameEn: "Competitive Intelligence Report",
                nameFr: "Rapport d'intelligence concurrentielle",
                descriptionEn: "Comprehensive analysis of competitor strategies and market positioning",
                descriptionFr: "Analyse complète des stratégies concurrentielles et du positionnement sur le marché",
                approvers: "James H."
            },
            {
                id: "ma-004",
                nameEn: "Industry Benchmark Study",
                nameFr: "Étude de référence de l'industrie",
                descriptionEn: "Benchmarking analysis against industry standards and best practices",
                descriptionFr: "Analyse comparative par rapport aux normes de l'industrie et aux meilleures pratiques",
                approvers: "Maria G."
            },
            {
                id: "ma-005",
                nameEn: "Market Share Analysis",
                nameFr: "Analyse de part de marché",
                descriptionEn: "Detailed breakdown of market share by region and service line",
                descriptionFr: "Répartition détaillée de la part de marché par région et ligne de service",
                approvers: "Thomas A."
            },
            {
                id: "ma-006",
                nameEn: "Customer Acquisition Cost Report",
                nameFr: "Rapport du coût d'acquisition client",
                descriptionEn: "Analysis of customer acquisition costs across different channels",
                descriptionFr: "Analyse des coûts d'acquisition client à travers différents canaux",
                approvers: "Sophie L."
            },
            {
                id: "ma-007",
                nameEn: "Revenue Growth Forecast",
                nameFr: "Prévision de croissance des revenus",
                descriptionEn: "Predictive analysis of revenue growth patterns and projections",
                descriptionFr: "Analyse prédictive des modèles de croissance des revenus et projections",
                approvers: "Alex M."
            }
        ]
    },
    {
        categoryId: "financial-reporting",
        categoryName: "Financial Reporting",
        reports: [
            {
                id: "fr-001",
                nameEn: "Monthly P&L Statement",
                nameFr: "État des profits et pertes mensuel",
                descriptionEn: "Detailed monthly profit and loss analysis with variance reporting",
                descriptionFr: "Analyse détaillée mensuelle des profits et pertes avec rapport de variance",
                approvers: "Catherine D."
            },
            {
                id: "fr-002",
                nameEn: "Cash Flow Analysis",
                nameFr: "Analyse des flux de trésorerie",
                descriptionEn: "Weekly cash flow monitoring and forecasting report",
                descriptionFr: "Rapport de surveillance et de prévision des flux de trésorerie hebdomadaire",
                approvers: "Mark J."
            },
            {
                id: "fr-003",
                nameEn: "Budget vs Actual Report",
                nameFr: "Rapport budget vs réel",
                descriptionEn: "Comparison of budgeted amounts against actual performance",
                descriptionFr: "Comparaison des montants budgétés par rapport à la performance réelle",
                approvers: "Nicole P."
            },
            {
                id: "fr-004",
                nameEn: "Expense Category Analysis",
                nameFr: "Analyse des catégories de dépenses",
                descriptionEn: "Breakdown of expenses by category with trend analysis",
                descriptionFr: "Répartition des dépenses par catégorie avec analyse des tendances",
                approvers: "Kevin R."
            },
            {
                id: "fr-005",
                nameEn: "Revenue Recognition Report",
                nameFr: "Rapport de reconnaissance des revenus",
                descriptionEn: "Monthly revenue recognition analysis and compliance reporting",
                descriptionFr: "Analyse mensuelle de reconnaissance des revenus et rapport de conformité",
                approvers: "Amanda C."
            }
        ]
    },
    {
        categoryId: "operations",
        categoryName: "Operations",
        reports: [
            {
                id: "op-001",
                nameEn: "Daily Operations Dashboard",
                nameFr: "Tableau de bord des opérations quotidiennes",
                descriptionEn: "Real-time operational metrics and KPI tracking",
                descriptionFr: "Métriques opérationnelles en temps réel et suivi des KPI",
                approvers: "Steven K."
            },
            {
                id: "op-002",
                nameEn: "Process Efficiency Report",
                nameFr: "Rapport d'efficacité des processus",
                descriptionEn: "Analysis of process efficiency and improvement opportunities",
                descriptionFr: "Analyse de l'efficacité des processus et opportunités d'amélioration",
                approvers: "Rachel F."
            },
            {
                id: "op-003",
                nameEn: "Quality Control Metrics",
                nameFr: "Métriques de contrôle qualité",
                descriptionEn: "Quality assurance metrics and defect tracking",
                descriptionFr: "Métriques d'assurance qualité et suivi des défauts",
                approvers: "Brian N."
            },
            {
                id: "op-004",
                nameEn: "Capacity Planning Report",
                nameFr: "Rapport de planification de capacité",
                descriptionEn: "Resource capacity analysis and future planning",
                descriptionFr: "Analyse de la capacité des ressources et planification future",
                approvers: "Laura S."
            },
            {
                id: "op-005",
                nameEn: "Vendor Performance Analysis",
                nameFr: "Analyse de performance des fournisseurs",
                descriptionEn: "Evaluation of vendor performance and contract compliance",
                descriptionFr: "Évaluation de la performance des fournisseurs et conformité contractuelle",
                approvers: "Daniel M."
            },
            {
                id: "op-006",
                nameEn: "Inventory Management Report",
                nameFr: "Rapport de gestion d'inventaire",
                descriptionEn: "Inventory levels, turnover rates, and optimization recommendations",
                descriptionFr: "Niveaux d'inventaire, taux de rotation et recommandations d'optimisation",
                approvers: "Michelle T."
            },
            {
                id: "op-007",
                nameEn: "Service Level Agreement Tracking",
                nameFr: "Suivi des accords de niveau de service",
                descriptionEn: "SLA compliance monitoring and performance metrics",
                descriptionFr: "Surveillance de la conformité SLA et métriques de performance",
                approvers: "Christopher B."
            },
            {
                id: "op-008",
                nameEn: "Maintenance Schedule Report",
                nameFr: "Rapport de calendrier de maintenance",
                descriptionEn: "Preventive maintenance scheduling and equipment status",
                descriptionFr: "Planification de maintenance préventive et statut de l'équipement",
                approvers: "Jessica R."
            }
        ]
    },
    {
        categoryId: "human-resources",
        categoryName: "Human Resources",
        reports: [
            {
                id: "hr-001",
                nameEn: "Employee Turnover Analysis",
                nameFr: "Analyse du roulement des employés",
                descriptionEn: "Analysis of employee turnover rates and retention strategies",
                descriptionFr: "Analyse des taux de roulement des employés et stratégies de rétention",
                approvers: "Patricia W."
            },
            {
                id: "hr-002",
                nameEn: "Compensation Benchmarking",
                nameFr: "Référencement de compensation",
                descriptionEn: "Market compensation analysis and salary benchmarking",
                descriptionFr: "Analyse de compensation du marché et référencement salarial",
                approvers: "Gregory H."
            },
            {
                id: "hr-003",
                nameEn: "Diversity and Inclusion Metrics",
                nameFr: "Métriques de diversité et inclusion",
                descriptionEn: "Diversity statistics and inclusion program effectiveness",
                descriptionFr: "Statistiques de diversité et efficacité des programmes d'inclusion",
                approvers: "Samantha L."
            },
            {
                id: "hr-004",
                nameEn: "Training ROI Analysis",
                nameFr: "Analyse ROI de formation",
                descriptionEn: "Return on investment analysis for training programs",
                descriptionFr: "Analyse du retour sur investissement pour les programmes de formation",
                approvers: "Timothy D."
            },
            {
                id: "hr-005",
                nameEn: "Absenteeism Report",
                nameFr: "Rapport d'absentéisme",
                descriptionEn: "Employee absenteeism patterns and impact analysis",
                descriptionFr: "Modèles d'absentéisme des employés et analyse d'impact",
                approvers: "Victoria G."
            },
            {
                id: "hr-006",
                nameEn: "Succession Planning Dashboard",
                nameFr: "Tableau de bord de planification de succession",
                descriptionEn: "Leadership pipeline and succession planning metrics",
                descriptionFr: "Pipeline de leadership et métriques de planification de succession",
                approvers: "Jonathan P."
            }
        ]
    },
    {
        categoryId: "technology",
        categoryName: "Technology",
        reports: [
            {
                id: "tech-001",
                nameEn: "System Performance Monitoring",
                nameFr: "Surveillance de performance système",
                descriptionEn: "Real-time system performance metrics and uptime analysis",
                descriptionFr: "Métriques de performance système en temps réel et analyse de disponibilité",
                approvers: "Nathan C."
            },
            {
                id: "tech-002",
                nameEn: "Security Incident Report",
                nameFr: "Rapport d'incident de sécurité",
                descriptionEn: "Security breach analysis and incident response tracking",
                descriptionFr: "Analyse des violations de sécurité et suivi de réponse aux incidents",
                approvers: "Melissa J."
            },
            {
                id: "tech-003",
                nameEn: "Software License Compliance",
                nameFr: "Conformité des licences logicielles",
                descriptionEn: "Software license usage and compliance monitoring",
                descriptionFr: "Utilisation des licences logicielles et surveillance de conformité",
                approvers: "Ryan E."
            },
            {
                id: "tech-004",
                nameEn: "Data Backup and Recovery Status",
                nameFr: "Statut de sauvegarde et récupération de données",
                descriptionEn: "Backup success rates and disaster recovery readiness",
                descriptionFr: "Taux de succès de sauvegarde et préparation de récupération de catastrophe",
                approvers: "Ashley K."
            },
            {
                id: "tech-005",
                nameEn: "Network Traffic Analysis",
                nameFr: "Analyse du trafic réseau",
                descriptionEn: "Network usage patterns and bandwidth optimization",
                descriptionFr: "Modèles d'utilisation réseau et optimisation de bande passante",
                approvers: "Benjamin F."
            },
            {
                id: "tech-006",
                nameEn: "Cloud Cost Optimization",
                nameFr: "Optimisation des coûts cloud",
                descriptionEn: "Cloud resource usage and cost optimization recommendations",
                descriptionFr: "Utilisation des ressources cloud et recommandations d'optimisation des coûts",
                approvers: "Stephanie M."
            },
            {
                id: "tech-007",
                nameEn: "Application Performance Report",
                nameFr: "Rapport de performance d'application",
                descriptionEn: "Application response times and user experience metrics",
                descriptionFr: "Temps de réponse d'application et métriques d'expérience utilisateur",
                approvers: "Tyler R."
            }
        ]
    },
    {
        categoryId: "compliance",
        categoryName: "Compliance and Risk Management",
        reports: [
            {
                id: "comp-001",
                nameEn: "Regulatory Compliance Dashboard",
                nameFr: "Tableau de bord de conformité réglementaire",
                descriptionEn: "Compliance status across all regulatory requirements",
                descriptionFr: "Statut de conformité à travers toutes les exigences réglementaires",
                approvers: "Elizabeth H."
            },
            {
                id: "comp-002",
                nameEn: "Risk Assessment Report",
                nameFr: "Rapport d'évaluation des risques",
                descriptionEn: "Comprehensive risk analysis and mitigation strategies",
                descriptionFr: "Analyse complète des risques et stratégies d'atténuation",
                approvers: "Matthew L."
            },
            {
                id: "comp-003",
                nameEn: "Audit Findings Tracker",
                nameFr: "Suivi des conclusions d'audit",
                descriptionEn: "Internal and external audit findings and remediation status",
                descriptionFr: "Conclusions d'audit interne et externe et statut de remédiation",
                approvers: "Rebecca S."
            },
            {
                id: "comp-004",
                nameEn: "Policy Compliance Monitoring",
                nameFr: "Surveillance de conformité des politiques",
                descriptionEn: "Employee compliance with company policies and procedures",
                descriptionFr: "Conformité des employés aux politiques et procédures de l'entreprise",
                approvers: "Joshua T."
            },
            {
                id: "comp-005",
                nameEn: "Data Privacy Impact Assessment",
                nameFr: "Évaluation d'impact sur la confidentialité des données",
                descriptionEn: "GDPR and privacy regulation compliance analysis",
                descriptionFr: "Analyse de conformité RGPD et réglementations de confidentialité",
                approvers: "Hannah B."
            }
        ]
    },
    {
        categoryId: "sales-marketing",
        categoryName: "Sales and Marketing",
        reports: [
            {
                id: "sm-001",
                nameEn: "Sales Pipeline Analysis",
                nameFr: "Analyse du pipeline de ventes",
                descriptionEn: "Sales funnel performance and conversion rate analysis",
                descriptionFr: "Performance de l'entonnoir de ventes et analyse du taux de conversion",
                approvers: "Andrew M."
            },
            {
                id: "sm-002",
                nameEn: "Marketing Campaign ROI",
                nameFr: "ROI des campagnes marketing",
                descriptionEn: "Return on investment analysis for marketing campaigns",
                descriptionFr: "Analyse du retour sur investissement pour les campagnes marketing",
                approvers: "Christina V."
            },
            {
                id: "sm-003",
                nameEn: "Lead Generation Report",
                nameFr: "Rapport de génération de prospects",
                descriptionEn: "Lead quality analysis and source effectiveness",
                descriptionFr: "Analyse de la qualité des prospects et efficacité des sources",
                approvers: "Derek W."
            },
            {
                id: "sm-004",
                nameEn: "Customer Lifetime Value Analysis",
                nameFr: "Analyse de la valeur vie client",
                descriptionEn: "CLV calculation and customer segmentation analysis",
                descriptionFr: "Calcul CLV et analyse de segmentation client",
                approvers: "Natalie Q."
            },
            {
                id: "sm-005",
                nameEn: "Social Media Engagement Metrics",
                nameFr: "Métriques d'engagement médias sociaux",
                descriptionEn: "Social media performance and engagement tracking",
                descriptionFr: "Performance des médias sociaux et suivi de l'engagement",
                approvers: "Carlos R."
            },
            {
                id: "sm-006",
                nameEn: "Territory Performance Report",
                nameFr: "Rapport de performance territoriale",
                descriptionEn: "Sales territory analysis and performance comparison",
                descriptionFr: "Analyse du territoire de ventes et comparaison de performance",
                approvers: "Olivia N."
            },
            {
                id: "sm-007",
                nameEn: "Email Marketing Analytics",
                nameFr: "Analytiques marketing par courriel",
                descriptionEn: "Email campaign performance and subscriber engagement",
                descriptionFr: "Performance des campagnes de courriel et engagement des abonnés",
                approvers: "Marcus D."
            },
            {
                id: "sm-008",
                nameEn: "Product Launch Analysis",
                nameFr: "Analyse de lancement de produit",
                descriptionEn: "New product launch performance and market reception",
                descriptionFr: "Performance de lancement de nouveau produit et réception du marché",
                approvers: "Isabella F."
            }
        ]
    },
    {
        categoryId: "customer-service",
        categoryName: "Customer Service",
        reports: [
            {
                id: "cs-001",
                nameEn: "Customer Support Ticket Analysis",
                nameFr: "Analyse des tickets de support client",
                descriptionEn: "Support ticket volume, resolution times, and satisfaction scores",
                descriptionFr: "Volume de tickets de support, temps de résolution et scores de satisfaction",
                approvers: "Gabriel P."
            },
            {
                id: "cs-002",
                nameEn: "First Call Resolution Rate",
                nameFr: "Taux de résolution au premier appel",
                descriptionEn: "Analysis of first call resolution effectiveness",
                descriptionFr: "Analyse de l'efficacité de résolution au premier appel",
                approvers: "Sophia G."
            },
            {
                id: "cs-003",
                nameEn: "Customer Feedback Analysis",
                nameFr: "Analyse des commentaires clients",
                descriptionEn: "Customer feedback trends and sentiment analysis",
                descriptionFr: "Tendances des commentaires clients et analyse de sentiment",
                approvers: "Lucas H."
            },
            {
                id: "cs-004",
                nameEn: "Agent Performance Metrics",
                nameFr: "Métriques de performance des agents",
                descriptionEn: "Customer service agent productivity and quality metrics",
                descriptionFr: "Métriques de productivité et qualité des agents de service client",
                approvers: "Mia K."
            },
            {
                id: "cs-005",
                nameEn: "Call Center Analytics",
                nameFr: "Analytiques du centre d'appels",
                descriptionEn: "Call volume patterns, wait times, and operational efficiency",
                descriptionFr: "Modèles de volume d'appels, temps d'attente et efficacité opérationnelle",
                approvers: "Ethan J."
            },
            {
                id: "cs-006",
                nameEn: "Customer Churn Analysis",
                nameFr: "Analyse de désabonnement client",
                descriptionEn: "Customer churn patterns and retention strategies",
                descriptionFr: "Modèles de désabonnement client et stratégies de rétention",
                approvers: "Ava L."
            }
        ]
    },
    {
        categoryId: "strategic-planning",
        categoryName: "Strategic Planning",
        reports: [
            {
                id: "sp-001",
                nameEn: "Strategic Initiative Progress",
                nameFr: "Progrès des initiatives stratégiques",
                descriptionEn: "Progress tracking of strategic initiatives and milestones",
                descriptionFr: "Suivi des progrès des initiatives stratégiques et jalons",
                approvers: "William S."
            },
            {
                id: "sp-002",
                nameEn: "Market Opportunity Assessment",
                nameFr: "Évaluation des opportunités de marché",
                descriptionEn: "Analysis of new market opportunities and expansion potential",
                descriptionFr: "Analyse des nouvelles opportunités de marché et potentiel d'expansion",
                approvers: "Charlotte M."
            },
            {
                id: "sp-003",
                nameEn: "Competitive Positioning Analysis",
                nameFr: "Analyse de positionnement concurrentiel",
                descriptionEn: "Strategic positioning relative to competitors",
                descriptionFr: "Positionnement stratégique par rapport aux concurrents",
                approvers: "James T."
            },
            {
                id: "sp-004",
                nameEn: "Resource Allocation Strategy",
                nameFr: "Stratégie d'allocation des ressources",
                descriptionEn: "Strategic resource allocation and investment priorities",
                descriptionFr: "Allocation stratégique des ressources et priorités d'investissement",
                approvers: "Amelia R."
            },
            {
                id: "sp-005",
                nameEn: "Long-term Growth Projections",
                nameFr: "Projections de croissance à long terme",
                descriptionEn: "5-year growth forecasts and strategic planning scenarios",
                descriptionFr: "Prévisions de croissance sur 5 ans et scénarios de planification stratégique",
                approvers: "Benjamin C."
            },
            {
                id: "sp-006",
                nameEn: "Innovation Pipeline Report",
                nameFr: "Rapport du pipeline d'innovation",
                descriptionEn: "Innovation projects and R&D investment analysis",
                descriptionFr: "Projets d'innovation et analyse d'investissement R&D",
                approvers: "Harper B."
            },
            {
                id: "sp-007",
                nameEn: "Partnership Evaluation Report",
                nameFr: "Rapport d'évaluation de partenariat",
                descriptionEn: "Strategic partnership opportunities and alliance performance",
                descriptionFr: "Opportunités de partenariat stratégique et performance d'alliance",
                approvers: "Mason W."
            },
            {
                id: "sp-008",
                nameEn: "Digital Transformation Roadmap",
                nameFr: "Feuille de route de transformation numérique",
                descriptionEn: "Digital transformation progress and technology adoption",
                descriptionFr: "Progrès de transformation numérique et adoption technologique",
                approvers: "Evelyn D."
            },
            {
                id: "sp-009",
                nameEn: "Sustainability Impact Assessment",
                nameFr: "Évaluation d'impact de durabilité",
                descriptionEn: "Environmental and social impact of business operations",
                descriptionFr: "Impact environnemental et social des opérations commerciales",
                approvers: "Logan F."
            }
        ]
    }
];
